'use client';

import { useClientTranslation } from '@lib/i18n/client';
import { TextButton } from '@tuic/web-compositions/core/TextButton';
import { useCallback, useState } from 'react';

import type { PhaserClientData } from '../types';
import type { TFunction } from '@tuic/i18n';
import type { TextButtonProps } from '@tuic/web-compositions/core/TextButton';
import type { FC, MouseEventHandler } from 'react';

type Props = {
  data?: PhaserClientData;
};

export const CopyBookingButton: FC<Props> = ({ data }) => {
  const { t } = useClientTranslation();
  const [copied, setCopied] = useState<boolean>();

  const handleBookingCopy: MouseEventHandler = useCallback(
    async ev => {
      ev.preventDefault();

      try {
        await navigator.clipboard.writeText(
          data?.serializedPhasedBooking ?? '',
        );
        setCopied(true);
      } catch (e) {
        setCopied(false);
      } finally {
        setTimeout(() => setCopied(undefined), 3000);
      }
    },
    [data?.serializedPhasedBooking],
  );

  return (
    <TextButton
      onClick={handleBookingCopy}
      iconSize="xs"
      {...getCopyButtonProps(t, copied)}
    />
  );
};

const getCopyButtonProps = (
  t: TFunction,
  copied: boolean | undefined,
): TextButtonProps => {
  if (typeof copied === 'undefined') {
    return {
      iconLeft: 'receipt',
      children: t('Buchung in Zwischenablage kopieren'),
    };
  }

  if (copied) {
    return {
      iconLeft: 'check',
      children: t('Erfolgreich kopiert'),
    };
  }

  return {
    iconLeft: 'cancel',
    children: t('Kopieren gescheitert'),
  };
};
